import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from './store';
import { tap, take, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root'
})
export class OdmAuthGuardGuard implements CanActivate {
  loginStatus$: Observable<boolean>;
  constructor(
    private store: Store<fromStore.State>,
    private router: Router
  ) {
    this.loginStatus$ = store.select(fromStore.getIsLogin);
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return this.checkLogin(url);
  }
  // 未登入，才可進入頁面
  checkLogin(url: string): any {
    return this.loginStatus$.pipe(
      map(status => {
        if (status) {
          this.router.navigate(['/index']);
          return false;
        } else {
          return true;
        }
      }),
      take(1)
    );
  }
}
